var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 20,
    fill: "none",
    viewBox: "0 0 12 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#716E6E",
    d: "M10.4583 0H1.54178C0.798918 0 0.190918 0.607429 0.190918 1.35086V18.6486C0.190918 19.392 0.798918 20 1.54178 20H10.4583C11.2012 20 11.8092 19.3931 11.8092 18.6491V1.35086C11.8092 0.607429 11.2012 0 10.4583 0ZM4.57378 0.973714H7.42635C7.51663 0.973714 7.58978 1.04686 7.58978 1.13771C7.58978 1.228 7.51663 1.30114 7.42635 1.30114H4.57378C4.48349 1.30114 4.41035 1.228 4.41035 1.13771C4.41035 1.04686 4.48349 0.973714 4.57378 0.973714ZM6.00006 19.3246C5.62692 19.3246 5.32463 19.0223 5.32463 18.6486C5.32463 18.2749 5.62692 17.9731 6.00006 17.9731C6.3732 17.9731 6.67549 18.2749 6.67549 18.6486C6.67549 19.0223 6.3732 19.3246 6.00006 19.3246ZM10.8692 17.5H1.13092V2.14229H10.8692V17.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.cd160f8535a215f920fc942dab310b17.svg";
export { ForwardRef as ReactComponent };